
<div class="badge-status {{getStatusColor()}}">
    <span [style.color]="status === StatusPropostaFiltro.PropostaVencida ? '#FFF' : null">{{getStatusText()}}</span>
</div>
